// extracted by mini-css-extract-plugin
module.exports = {"layoutWrapper":"Layout_layoutWrapper__23nZg","fadeIn":"Layout_fadeIn__1MOJw","timer":"Layout_timer__3yOyN","timerP":"Layout_timerP__25l_s"};